import type { TypographyVariantsOptions } from "@mui/material/styles";

export const typography = {
	fontFamily: "'Inter', 'Plus Jakarta Sans', sans-serif",
	// Use pixel values for consistent sizing across environments
	body1: { fontSize: "16px", fontWeight: 400, lineHeight: 1.5 },
	body2: { fontSize: "14px", fontWeight: 400, lineHeight: 1.57 },
	button: { fontWeight: 500, fontSize: "14px" },
	caption: { fontSize: "12px", fontWeight: 400, lineHeight: 1.66 },
	subtitle1: { fontSize: "16px", fontWeight: 500, lineHeight: 1.57 },
	subtitle2: { fontSize: "14px", fontWeight: 500, lineHeight: 1.57 },
	overline: {
		fontSize: "12px",
		fontWeight: 500,
		letterSpacing: "0.5px",
		lineHeight: 2.5,
		textTransform: "uppercase",
	},
	h1: { fontSize: "56px", fontWeight: 600, lineHeight: 1.2 },
	h2: { fontSize: "48px", fontWeight: 600, lineHeight: 1.2 },
	h3: { fontSize: "36px", fontWeight: 600, lineHeight: 1.2 },
	h4: { fontSize: "32px", fontWeight: 600, lineHeight: 1.2 },
	h5: { fontSize: "24px", fontWeight: 500, lineHeight: 1.2 },
	h6: { fontSize: "18px", fontWeight: 500, lineHeight: 1.2 },
} satisfies TypographyVariantsOptions;
